import { RefreshCw } from 'lucide-react';
import { formatStatsAsOf } from '../../../lib/publishing/postStats';
import { cn } from '../../../lib/utils';

// Organic Social Reporting — the as-of line. THE honesty field: every analytics
// figure on the page is a snapshot as-of Zernio's last sync, never live. Reuses
// the postStats formatStatsAsOf posture (community-inbox reaction-count lineage).
// The line ALWAYS renders (even "Last sync time unknown") — an absent caveat reads
// as live.
export function AsOfLine({
  lastSync,
  syncing,
  onRefresh,
}: {
  lastSync: string | null;
  syncing: boolean;
  onRefresh: () => void;
}) {
  const asOf = formatStatsAsOf(lastSync, new Date());
  return (
    <div className="flex items-center gap-2 text-xs text-slate-500">
      <span>Figures are a snapshot — {asOf}.</span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={syncing}
        className="inline-flex items-center gap-1 rounded border border-slate-200 bg-white px-2 py-0.5 font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-60"
      >
        <RefreshCw className={cn('h-3 w-3', syncing && 'animate-spin')} aria-hidden />
        {syncing ? 'Syncing…' : 'Refresh'}
      </button>
    </div>
  );
}
